import script from "./RegionUI.vue?vue&type=script&setup=true&lang=js"
export * from "./RegionUI.vue?vue&type=script&setup=true&lang=js"

import "./RegionUI.vue?vue&type=style&index=0&id=31b779ef&scoped=true&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31b779ef"]])

export default __exports__